export const PEOPLE_TRAINING_URL = 'https://people.sentryvend.com/account/training';
